var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEgg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.15 25.1579V19.4737H40.05V15.6842H37.95V13.7895H35.85V11.8947H31.65V10H25.35V11.8947H21.15V13.7895H19.05V15.6842H16.95V19.4737H14.85V25.1579H12.75V36.5263H14.85V40.3158H16.95V42.2105H19.05V44.1053H23.25V46H33.75V44.1053H37.95V42.2105H40.05V40.3158H42.15V36.5263H44.25V25.1579H42.15Z",
    fill: "#0055FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7486 23.233V19.0268H35.1623V16.2227H33.576V14.8206H31.9897V13.4185H28.817V10.8325C27.5479 10.8325 27.2307 10.8325 25.9616 10.8325V12.3125H23.5821V13.4185H21.8372V14.8206H19.6163V16.2227H17.7127V19.0268V20.1562H16.1264V23.233V25.9281H14.54V31.6454H16.1264V34.4495H17.7127V35.8516H19.299V37.2536H22.4717V38.6557H30.4033V37.2536H33.576V35.8516H35.1623V34.4495H36.7486V31.6454H38.335V23.233H36.7486Z",
    fill: "#6B9DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8784 21.9322V21.0442H24.5129V19.8602H25.0311V18.4114H24.5658L24.5129 17.6403H24.1005V17.1963H23.5611V16.7523H22.1334V17.1963H21.3085V18.0064H20.3779V18.4114H19.6165V19.2215H19.2992V20.4366H18.9819V22.8669H19.4473V23.677H19.9126V24.082H20.3779V24.487H20.8644V24.8921H21.7739V24.487H22.1334V24.082H22.6093V23.7081L23.1064 23.677V22.8669H23.5611V21.9322H23.8784Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/EGG.8babd6c1fe27f3854782a2dbf47f91d1.svg";
export { ForwardRef as ReactComponent };